import { MasterDataEntityPage } from "../MasterDataEntityPage"
import { MasterDataPanelLayout } from "../MasterDataPanelLayout"
import { ProductDetailPanel } from "../products/ProductDetailPanel"
import { ProductListPanel } from "../products/ProductListPanel"
import { useRowMultiSelect } from "../useRowMultiSelect"

export function ProductsPage() {
  const { selectedIds, toggleSelected, removeIds } = useRowMultiSelect()

  return (
    <MasterDataEntityPage
      titleKey="MC_MD_TAB_PRODUCTS"
      helpArticleId="master-data.products"
    >
      <MasterDataPanelLayout
        listPanel={
          <ProductListPanel
            selectedIds={selectedIds}
            onToggleSelected={toggleSelected}
          />
        }
        detailPanel={
          <ProductDetailPanel
            selectedIds={selectedIds}
            onRemoveIds={removeIds}
          />
        }
      />
    </MasterDataEntityPage>
  )
}
